module.exports = __webpack_public_path__ + "static/email-template-welcome-6f4c16aaaeadae9560949322b78f2549.png";